import { useState } from 'react';
import { App } from '@back4app2/sdk';
import { DsButton } from '../ds';
import { RollbackIcon } from '../ds/icons';
import { canRunAppActions } from '../MyAppActions';
import RollbackDialog from './RollbackDialog';

/**
 * "Instant Rollback" on the Overview head, where Vercel puts it: the same
 * rollback as the Action menu's "Roll back to previous", one click from the
 * screen that shows what is live.
 *
 * Always opens: the dialog shows the live deployment, and the previous one to
 * roll back to only when there is one. Not drawn at all for someone who can't
 * deploy, like the Action menu.
 */
const InstantRollbackButton = ({ app }: { app: App }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!canRunAppActions(app)) {
    return null;
  }

  return (
    <>
      <DsButton
        variant="outline"
        size="md"
        ariaLabel="Instant Rollback"
        onClick={() => setIsOpen(true)}
        className="gap-2"
      >
        <RollbackIcon size={15} />
        <span className="hidden sm:inline">Instant Rollback</span>
      </DsButton>
      <RollbackDialog appId={app.id} open={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default InstantRollbackButton;
